module.exports = __webpack_public_path__ + "png/icons.png?0577da187b82fe0a4b639bb267fcda81";